import { DetailsSectionWrapper, ViewGrid, ViewPageListTab } from 'app/main/components/page-layouts';
import type { ViewPageContentTabType } from 'app/main/components/page-layouts/view/ViewPage';

import CompaniesDuplicatesView from './tabs/CompaniesDuplicatesView';
import CompaniesListItem from '../CompaniesListItem';
import CompaniesGridItem from '../CompaniesGridItem';

const tabs: ViewPageContentTabType[] = [
	{
		id: 'list',
		title: 'TAB_COMPANIES_ALL',
		hidden: ({ authorizer }) => {
			console.log(authorizer.cannot('view', 'companies-all'));
			return authorizer.cannot('view', 'companies-all');
		},
		content: props => <ViewPageListTab {...props} id="companiesView" itemLayout={CompaniesListItem} />
	},
	{
		id: 'customers',
		title: 'TAB_COMPANIES_CUSTOMERS',
		hidden: ({ authorizer }) => authorizer.cannot('view', 'companies-customers'),
		content: props => (
			<ViewPageListTab
				{...props}
				id="customersView"
				itemLayout={CompaniesListItem}
				defaultFilters={[{ filt_field: 'core_type', filt_clause: 'equals', filt_value: 'customers' }]}
				filters={[{ filt_field: 'comp_blocked', filt_clause: 'not_equal', filt_value: 1 }]}
			/>
		)
	},
	{
		id: 'suppliers',
		title: 'TAB_COMPANIES_SUPPLIERS',
		hidden: ({ authorizer }) => authorizer.cannot('view', 'companies-suppliers'),
		content: props => (
			<ViewPageListTab
				{...props}
				id="suppliersView"
				itemLayout={CompaniesListItem}
				defaultFilters={[{ filt_field: 'core_type', filt_clause: 'equals', filt_value: 'suppliers' }]}
				filters={[{ filt_field: 'comp_blocked', filt_clause: 'not_equal', filt_value: 1 }]}
			/>
		)
	},
	{
		id: 'others',
		title: 'TAB_COMPANIES_OTHERS',
		hidden: ({ authorizer }) => authorizer.cannot('view', 'companies-others'),
		content: props => (
			<ViewPageListTab
				{...props}
				id="othersView"
				itemLayout={CompaniesListItem}
				defaultFilters={[
					{ filt_field: 'core_type', filt_clause: 'not_in', filt_value: ['customers', 'suppliers'] }
				]}
				filters={[{ filt_field: 'comp_blocked', filt_clause: 'not_equal', filt_value: 1 }]}
			/>
		)
	},
	{
		id: 'business-cards',
		title: 'TAB_BUSINESS_CARD',
		content: ({ refresh, updateRefresh }) => (
			<DetailsSectionWrapper disablePadding>
				<ViewGrid
					module="companies"
					itemLayout={CompaniesGridItem}
					defaultFilters={[{ filt_field: 'comp_business_card_front', filt_clause: 'is_not_null' }]}
					refresh={refresh}
					updateRefresh={updateRefresh}
				/>
			</DetailsSectionWrapper>
		)
	},
	{
		id: 'duplicates',
		title: 'TAB_DUPLICATES',
		content: () => (
			<DetailsSectionWrapper disablePadding>
				<CompaniesDuplicatesView />
			</DetailsSectionWrapper>
		)
	}
];

export default tabs;
